import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { BTN_TXT } from '../../../../../constants'
import { useRFPSurveyContext } from '../../../RFPDetails/Providers/RFPSurveyContextProvider'
import { useRFPDetailsPopupContext } from '../../../RFPDetails/Providers/RFPDetailsPopupProvider'

export const ViewSurveyActions = () => {
  const rfpSurveyContext = useRFPSurveyContext()
  const { isSurveySubmitted } = rfpSurveyContext.state
  const { createSurveyPopup, submitSurveyPopup } = useRFPDetailsPopupContext()

  const handleClick = () => {
    const openAction = isSurveySubmitted
      ? submitSurveyPopup.actions.open
      : createSurveyPopup.actions.open

    openAction()
  }

  return (
    <Button onClick={handleClick} type={BUTTON_TYPES.LINK} upperCase>
      {BTN_TXT.VIEW_SURVEY}
    </Button>
  )
}
